<div class="form-group">
  <label [title]="titleText">Amount of tokens to show</label>
  <select class="form-control" [(ngModel)]="selectedSearchAmount" (ngModelChange)="identityAmountChanged($event)">
    @for (amount of searchAmount; track amount) {
      <option [title]="amount.descriptor!==null ? amount.descriptor : ''" [ngValue]="amount">{{amount.descriptor}}</option>
    }
  </select>
</div>